import { Menu } from "@mantine/core";
import { DateTime } from "luxon";
import { useTableProvider } from "../../provider";
import { TableMenu } from "../TableMenu";

export function TableItems() {
  const { data } = useTableProvider();

  return (
    <>
      {data.map((s) => (
        <tr key={s.id}>
          <td>{s.id}</td>
          <td>{s.name}</td>
          <td>{s.createdAt.toLocaleString(DateTime.DATETIME_MED)}</td>
          <td>
            <Menu>
              <TableMenu.Edit part={s} />
              <TableMenu.Delete part={s} />
            </Menu>
          </td>
        </tr>
      ))}
    </>
  );
}
